import { Builder } from '@builder.io/react';
import NewsletterForm from './NewsletterForm';

Builder.registerComponent(NewsletterForm, {
  name: 'NewsletterForm',
  inputs: [
    {
      name: 'minimise',
      type: 'boolean',
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Get CommCon Updates',
    },
    {
      name: 'firstNamePlaceholder',
      type: 'string',
      defaultValue: 'Your first name',
    },
    {
      name: 'lastNamePlaceholder',
      type: 'string',
      defaultValue: 'Your last name',
    },
    {
      name: 'emailPlaceholder',
      type: 'string',
      defaultValue: 'Your email address',
    },
    {
      name: 'buttonText',
      type: 'string',
      defaultValue: 'Submit',
    },
    {
      name: 'mailchimpUrl',
      friendlyName: 'MailChimp URL',
      type: 'longText',
      helperText: 'The URL from MailChimp that will subscribe this email to a specific list.'
    },
    {
      name: 'mailchimpTag',
      friendlyName: 'MailChimp Tag',
      type: 'string',
      helperText: 'The MailChimp tag that will subscribe this email to a specific list.'
    },
  ]
});

